function install(options, callback, errback) {
  callback || (callback = function() {});
  errback || (errback = function() {});

  
    if (
      'serviceWorker' in navigator &&
      (window.fetch || 'imageRendering' in document.documentElement.style) &&
      (window.location.protocol === 'https:' || window.location.hostname === 'localhost')
    ) {
      navigator.serviceWorker
        .register("/sw.js")
        .then(function() {
          callback({
            service: 'ServiceWorker'
          });
        }).catch(function(err) {
          errback({
            service: 'ServiceWorker'
          });

          return Promise.reject(err);
        });

      return;
    }
  

  
    if (window.applicationCache) {
      var directory = "/appcache/";
      var name = "manifest";

      var doLoad = function() {
        var page = directory + name + '.html';
        var iframe = document.createElement('iframe');

        iframe.src = page;
        iframe.style.display = 'none';

        document.body.appendChild(iframe);
      };

      if (document.readyState === 'complete') {
        setTimeout(doLoad);
      } else {
        window.addEventListener('load', doLoad);
      }

      return;
    }
  

  setTimeout(function() {
    callback({
      service: ''
    });
  });
}

exports.install = install;


//////////////////
// WEBPACK FOOTER
// ./~/offline-plugin/runtime.js
// module id = 899
// module chunks = 0